import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import GirmitiyaProudHero from "@/components/girmitiya-proud/GirmitiyaProudHero";
import GirmitiyaProudSection from "@/components/girmitiya-proud/GirmitiyaProudSection";
import LightboxModal from "@/components/girmitiya-proud/LightboxModal";
import QuickNavDrawer from "@/components/girmitiya-proud/QuickNavDrawer";
import ResearchCTA from "@/components/home/ResearchCTA";
import SeoHead from "@/components/seo/SeoHead";
import { breadcrumbJsonLd, seoFromPage } from "@/lib/seo";
import { GIRMITIYA_PROUD_SECTIONS } from "@/data/girmitiyaProudData";
export default function GirmitiyaProudPage() {
  const $ = _c(17);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = seoFromPage("girmitiyaProud");
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const seo = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      isOpen: false,
      images: [],
      currentIndex: 0,
      title: ""
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [lightboxState, setLightboxState] = useState(t1);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = (images, index, title) => {
      setLightboxState({
        isOpen: true,
        images,
        currentIndex: index,
        title
      });
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const handleOpenLightbox = t2;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      setLightboxState(_temp);
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const handleCloseLightbox = t3;
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = newIndex => {
      setLightboxState(prev_0 => ({
        ...prev_0,
        currentIndex: newIndex
      }));
    };
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const handleNavigateLightbox = t4;
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <SeoHead {...seo} jsonLd={breadcrumbJsonLd([{
      name: "Home",
      path: "/"
    }, {
      name: "Girmitiya Proud",
      path: "/girmitiya-proud"
    }])} />;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <GirmitiyaProudHero totalSections={GIRMITIYA_PROUD_SECTIONS.length} />;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  let t8;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="relative">{GIRMITIYA_PROUD_SECTIONS.map((section, idx) => <GirmitiyaProudSection key={section.id} section={section} isEven={idx % 2 === 0} onOpenLightbox={handleOpenLightbox} />)}</div>;
    t8 = <QuickNavDrawer sections={GIRMITIYA_PROUD_SECTIONS} />;
    $[7] = t7;
    $[8] = t8;
  } else {
    t7 = $[7];
    t8 = $[8];
  }
  let t9;
  if ($[9] !== lightboxState.currentIndex || $[10] !== lightboxState.images || $[11] !== lightboxState.isOpen || $[12] !== lightboxState.title) {
    t9 = <LightboxModal isOpen={lightboxState.isOpen} images={lightboxState.images} currentIndex={lightboxState.currentIndex} sectionTitle={lightboxState.title} onClose={handleCloseLightbox} onNavigate={handleNavigateLightbox} />;
    $[9] = lightboxState.currentIndex;
    $[10] = lightboxState.images;
    $[11] = lightboxState.isOpen;
    $[12] = lightboxState.title;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <ResearchCTA />;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== t9) {
    t11 = <>{t5}<main className="min-h-screen bg-[#F4EFE6]">{t6}{t7}{t8}{t9}{t10}</main></>;
    $[15] = t9;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  return t11;
}
function _temp(prev) {
  return {
    ...prev,
    isOpen: false
  };
}